import { Dealer } from './waybill.interfaces';

/**
 * Interface for Waybill entity based on Opr_Waybills backend entity
 */
export interface Waybill {
  // Primary identifiers
  waybillId: number;
  waybillCode: string;
  waybillPalletCode?: string;
  waybillShipmentCode: string;
  
  // Dates - using string for ISO format from backend OffsetDateTime
  waybillDate?: string;
  waybillEstimatedDeliveryDate?: string;
  waybillActualDeliveryDate?: string;
  waybillOriginalDeliveryDate?: string;
  waybillCreatedAt: string;
  waybillUpdatedAt?: string;
  
  // Delivery information
  waybillDeliveryMethod?: string;
  waybillDeliveryType?: string;
  waybillTransitTimeHours?: number;
  
  // Cargo information
  waybillTotalWeight?: number;
  waybillTotalVolume?: number;
  
  // Business codes
  waybillBrandCode?: string;
  waybillDealerCode?: string;
  waybillCarrierCode?: string;
  waybillCarrierName?: string;
  waybillClientCode?: string;
  
  // Location information
  waybillOriginLocation?: string;
  waybillDestinationLocation?: string;
  waybillTrackingNumber?: string;
  waybillLastKnownLocation?: string;
  
  // Status and flags (Y/N strings from database)
  waybillStatus: string; // Default: "ACTIVE"
  waybillFragile: string; // Default: "N"
  waybillHazardousMaterial: string; // Default: "N"
  waybillCustomsClearanceRequired: string; // Default: "N"
  
  // Audit fields
  waybillUpdatedBy?: string;
  waybillCreatedBy?: string;
  
  // Additional information
  waybillNote?: string;
  waybillFile?: string; // LOB field for file content
  waybillVersion: number; // Default: 0
  waybillAddressAlias?: string;
  
  // Geographical coordinates
  waybillLatitude?: number;
  waybillLongitude?: number;
  waybillOriginalLatitude?: number;
  waybillOriginalLongitude?: number;

  // Loading list (borderò) code reference
  waybillLoadingList?: string;
  waybillLoadingBay?: string;
  waybillLastMileOrigin?: string;

  // Scheduling
  waybillScheduleType?: string;
  waybillIsScheduleNight?: string;
  waybillSchedulesConditions?: string;
  waybillSchedulesPriority?: string;

  // Origin / routing
  waybillCreateType?: string;
  waybillDeliveryReason?: string;
  waybillExternalRoutingCode?: string;
  waybillOriginalWaybillCode?: string;
  waybillPlannedCarrierCode?: string;
  waybillExternalSystemCarrierCode?: string;

  // Dealer references
  waybillDealerCodeReceiver?: string;
  waybillDealerCodeOriginal?: string;

  // DDT attachments
  waybillDdtAttachments?: string;

  // Numero colli calcolato dal backend
  waybillParcelCount?: number;

  // Dealer associato, fornito dal backend nella risposta paginata delle bolle
  dealer?: Dealer;
}

/**
 * Enum for common waybill statuses
 */
export enum WaybillStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  UNSENT = 'UNSENT',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  NOT_DELIVERED = 'NOT_DELIVERED',
  RETURNED = 'RETURNED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  PROBLEM = 'PROBLEM'
}

/**
 * Enum for Y/N flag values
 */
export enum YesNoFlag {
  YES = 'Y',
  NO = 'N'
}
